module.exports = __webpack_public_path__ + "img/北京办公室3.f1609005.jpg";